/* eslint-disable @typescript-eslint/no-shadow,prefer-arrow/prefer-arrow-functions */
import { get } from 'lodash'
import { Theme, Tenant } from '@/types'
import * as loginDomainService from '@/services/login-domain'

interface LoginDomainStoreState {
  theme: Theme
  tenant: Tenant
  domain: string
}

export const state: LoginDomainStoreState = {
  theme: null,
  tenant: null,
  domain: null,
}

const getters = {
  loginHelpUrl(state: LoginDomainStoreState): string {
    return get(state.theme, 'links.loginHelpUrl')
  },

  loginHelpUrlLocales(state: LoginDomainStoreState): string {
    return get(state.theme, 'links.loginHelpUrlLocales')
  },

  contactSupportUrl(state: LoginDomainStoreState): string {
    return get(state.theme, 'links.contactSupportUrl')
  },

  resetPasswordHelpUrlLocales(state: LoginDomainStoreState): string {
    return get(state.theme, 'links.resetPasswordHelpUrlLocales')
  },

  logo(state: LoginDomainStoreState): string {
    return get(state.theme, 'images.logo')
  },

  themeName(state: LoginDomainStoreState): string {
    return get(state.theme, 'name')
  },

  themeCode(state: LoginDomainStoreState): string {
    return get(state.theme, 'code')
  },
}

const mutations = {
  storeTheme(state: LoginDomainStoreState, theme: Theme) {
    state.theme = theme
  },
  storeTenant(state: LoginDomainStoreState, tenant: Tenant) {
    state.tenant = tenant
  },
  storeDomain(state: LoginDomainStoreState, domain: string) {
    state.domain = domain
  },
}

const actions = {
  getLoginDomain({ commit }, domain: string) {
    return loginDomainService.getLoginDomain(domain).then((loginDomain) => {
      commit('storeTheme', loginDomain.theme)
      commit('storeTenant', loginDomain.tenant)
      commit('storeDomain', loginDomain.domain)
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
